import React from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite/no-important'
import styles from './styles'
import colors from './colors'
import sizes from './sizes'

export const Spinner = ({ className, size = 'medium', color = 'default' }) => {
  return (
    <div className={css(classes.base, classes[size], className)} data-cy="loading-container">
      <span
        className={`${css(
          classes.dot,
          classes['size__' + size],
          classes['color__' + color],
          classes.dot__first
        )}`}
      />
      <span
        className={`${css(
          classes.dot,
          classes['size__' + size],
          classes['color__' + color],
          classes.dot__second
        )}`}
      />
      <span
        className={`${css(
          classes.dot,
          classes['size__' + size],
          classes['color__' + color],
          classes.dot__third
        )}`}
      />
    </div>
  )
}

Spinner.propTypes = {
  color: PropTypes.oneOf(colors),
  size: PropTypes.oneOf(sizes),
}

// Moved to function parameters above

const classes = StyleSheet.create(styles)

export default Spinner
